const DEMO_PLEDGE_STORAGE_KEY = 'placepledge_demo_pledge';

export const saveDemoPledge = (demoPledge) => {
  window.localStorage.setItem(DEMO_PLEDGE_STORAGE_KEY, JSON.stringify(demoPledge));
};

export const loadDemoPledge = () => {
  try {
    const demoPledge = JSON.parse(window.localStorage.getItem(DEMO_PLEDGE_STORAGE_KEY) || 'null');

    if (!demoPledge || !demoPledge.alarm || !demoPledge.location) {
      return null;
    }

    return demoPledge;
  } catch (error) {
    return null;
  }
};

export const clearDemoPledge = () => {
  window.localStorage.removeItem(DEMO_PLEDGE_STORAGE_KEY);
};
